import { Vector3, Spherical, Quaternion } from 'three';
import * as TWEEN from '../libs/TWEEN';
import FOUR from '../libs/viewcube';

export default class FOURcube {
  constructor(targetElement, cameraManager, mode) {
    this.viewcubeElement = targetElement;
    this.camera = cameraManager[mode].camera;
    this.orbitControls = cameraManager[mode].controls;

    this.viewcube = new FOUR.Viewcube({
      domElement: this.viewcubeElement,
      labelSize: 64,
      labelFontSize: 12,
      updateTween: true,
      display: {
        //sceneAxis: true
        //cameraAxis: true,
        //controlAxis: true,
      },
      viewport: {
        camera: this.camera,
      }
    });

    this.orbitControls.addEventListener('change', () => {
//   // sync viewcube with new camera rotation
      this.viewcube.updateOrientation();
    });
    this.viewcube.addEventListener('update', (event) => {
//TODO: position and rotate camera around it's target
      var yawPitch = event.direction;
      var view = event.view;
      this.rotateCameraAroundByYawPitch(this.camera, this.orbitControls.target, yawPitch.yaw, yawPitch.pitch, true);
    });

    this.viewcube.enable()
  }

  update() {
    this.viewcube.update()
  }

  getCameraYawPitch(camera, target) {
    var spherical = new Spherical();
    var offset = new Vector3();

    // so camera.up is the orbit axis
    var quat = new Quaternion().setFromUnitVectors(camera.up, new Vector3(0, 1, 0));
    var position = camera.position;

    offset.copy(position).sub(target);

    // rotate offset to "y-axis-is-up" space
    offset.applyQuaternion(quat);

    // angle from z-axis around y-axis
    spherical.setFromVector3(offset);

    return {
      yaw: spherical.theta,
      pitch: Math.PI / 2 - spherical.phi
    };
  }

  rotateCameraAroundByYawPitch(camera, target, yaw, pitch, animate) {
// TODO: add tween here.... somehow
    if (typeof animate === 'undefined')
      animate = false;

    if (!animate) {
      this.setCameraYawPitch(camera, target, yaw, pitch);
    } else {
      this.tweenCamera(camera, target, yaw, pitch);
    }

  }

  tweenCamera(camera, target, yaw, pitch) {
    var start = this.getCameraYawPitch(camera, target);
    var finish = {
      yaw: yaw,
      pitch: pitch
    };

    var tween = new TWEEN.Tween(start).to(finish, 1000);
    tween.easing(TWEEN.Easing.Cubic.InOut);
    tween.onComplete(() => {
      this.setCameraYawPitch(camera, target, start.yaw, start.pitch);
      tween.stop();
    });
    tween.onUpdate(() => {
      this.setCameraYawPitch(camera, target, start.yaw, start.pitch);
    });
    tween.start();
  }

  setCameraYawPitch(camera, target, yaw, pitch) {
// console.log("setCameraYawPitch", yaw.toFixed(5), pitch.toFixed(5));
    var spherical = new Spherical();
    var offset = new Vector3();

// so camera.up is the orbit axis
    var quat = new Quaternion().setFromUnitVectors(camera.up, new Vector3(0, 1, 0));
    var quatInverse = quat.clone().inverse();
    var position = camera.position;

    offset.copy(position).sub(target);

// rotate offset to "y-axis-is-up" space
    offset.applyQuaternion(quat);

// angle from z-axis around y-axis
    spherical.setFromVector3(offset);

    var thetaDelta = yaw - spherical.theta;
    var phiDelta = (-pitch + Math.PI / 2) - spherical.phi;

    spherical.theta += thetaDelta;
    spherical.phi += phiDelta;

    spherical.makeSafe();
    offset.setFromSpherical(spherical);

// rotate offset back to "camera-up-vector-is-up" space
    offset.applyQuaternion(quatInverse);

    camera.position.copy(target).add(offset);
    camera.lookAt(target);
  }
}

// viewcube.enable();
// }
